import {
  SOCIAL_TRADING_PROVIDERS_API,
  SOCIAL_TRADING_PROVIDERS_OFFERS_API,
  SocialTradingProviderIdParamValue,
  SOCIAL_TRADING_SUBSCRIPTIONS_API,
  SOCIAL_TRADING_PROVIDERS_CONFIG_API,
  FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS_API,
  SUBMIT_SOCIAL_TRADING_PROVIDER_API,
  SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER_API,
  FETCH_SOCIAL_TRADING_PROVIDER_DETAILS_API,
  FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART_API,
  FETCH_SOCIAL_TRADING_PROVIDER_METRICS_API,
  FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS_API,
  FETCH_SOCIAL_TRADING_PROVIDER_DEALS_API,
  UPDATE_SOCIAL_TRADING_PROVIDER_API,
  FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO_API,
  UPDATE_SOCIAL_TRADING_SUBSCRIPTION_API,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS_API,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS_API,
  SocialTradingSubscriptionIdParamValue,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS_API,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS_API,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK_API,
  UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK_API,
  DELETE_SOCIAL_TRADING_SUBSCRIPTION_API,
  FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO_API,
  FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS_API,
  SocialTradingOfferIdParamValue,
  FETCH_SOCIAL_TRADING_OFFER_DETAILS_API,
  FETCH_SOCIAL_TRADING_FEES_API,
  SUBSCRIBE_AGGREGATE_API,
  SUBMIT_PROVIDER_APPLICATION_API,
  SUBMIT_PROVIDER_AGGREGATE_API,
  FETCH_SOCIAL_TRADING_RATE_PROFILE_API,
  SocialTradingProfileIdParamValue,
  FETCH_SOCIAL_TRADING_HISTORY_INDICATORS_API,
  FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT_API,
  FETCH_SOCIAL_TRADING_TRADE_REPORT_API,
  SocialTradingAccountIdParamValue,
} from "_constants";
import { socialTradingRequest } from "_helpers";

const fetchSocialTradingProviders = () => {
  return socialTradingRequest.get(SOCIAL_TRADING_PROVIDERS_API, {
    params: { limit: 1000 },
  });
};

const fetchSocialTradingProviderOffers = (socialTradingProviderDetails) => {
  const url = SOCIAL_TRADING_PROVIDERS_OFFERS_API.replace(
    SocialTradingProviderIdParamValue,
    socialTradingProviderDetails.providerId
  );
  return socialTradingRequest.get(url);
};

const subscribeToSocialTradingProvider = (
  socialTradingProviderSubscriptionDetails
) => {
  return socialTradingRequest.post(
    SOCIAL_TRADING_SUBSCRIPTIONS_API,
    socialTradingProviderSubscriptionDetails
  );
};

const submitSocialTradingProvider = (submitSocialTradingProviderDetails) => {
  const { providerId, ...data } = submitSocialTradingProviderDetails || {};
  const url = SUBMIT_SOCIAL_TRADING_PROVIDER_API.replace(
    SocialTradingProviderIdParamValue,
    providerId
  );
  return socialTradingRequest.post(url, data);
};

const submitSocialTradingProviderOffer = (providerOfferDetails) => {
  return socialTradingRequest.post(
    SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER_API,
    providerOfferDetails
  );
};

const fetchSocialTradingProvidersConfig = () => {
  return socialTradingRequest.get(SOCIAL_TRADING_PROVIDERS_CONFIG_API);
};

const fetchSocialTradingProviderPositions = (
  socialTradingProviderPositionsDetails
) => {
  const url = FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS_API.replace(
    SocialTradingProviderIdParamValue,
    socialTradingProviderPositionsDetails.providerId
  );
  return socialTradingRequest.get(url);
};

const fetchSocialTradingProviderDetails = (socialTradingProviderDetails) => {
  const url = FETCH_SOCIAL_TRADING_PROVIDER_DETAILS_API.replace(
    SocialTradingProviderIdParamValue,
    socialTradingProviderDetails.providerId
  );
  return socialTradingRequest.get(url);
};

const fetchSocialTradingHistoryDailyChart = (
  socialTradingHistoryDailyChartDetails
) => {
  const { accId, frequency, ...params } =
    socialTradingHistoryDailyChartDetails || {};

  return socialTradingRequest.get(
    `${FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART_API}/${accId}/${frequency}`,
    { params }
  );
};

const fetchSocialTradingProviderMetrics = (
  socialTradingProviderMetricsParams
) => {
  const url = FETCH_SOCIAL_TRADING_PROVIDER_METRICS_API.replace(
    SocialTradingProviderIdParamValue,
    socialTradingProviderMetricsParams.providerId
  );
  return socialTradingRequest.get(url);
};

const fetchSocialTradingProviderSubscriptions = (
  socialTradingProviderSubscriptionsParams
) => {
  const { providerId, ...params } =
    socialTradingProviderSubscriptionsParams || {};
  const url = FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS_API.replace(
    SocialTradingProviderIdParamValue,
    providerId
  );
  return socialTradingRequest.get(url, { params });
};

const fetchSocialTradingProviderDeals = (socialTradingProviderDealsParams) => {
  const { providerId, ...params } = socialTradingProviderDealsParams || {};

  const url = FETCH_SOCIAL_TRADING_PROVIDER_DEALS_API.replace(
    SocialTradingProviderIdParamValue,
    providerId
  );
  return socialTradingRequest.get(url, { params });
};

const updateSocialTradingProvider = (updateSocialTradingProviderDetails) => {
  const { providerId } = updateSocialTradingProviderDetails || {};
  return socialTradingRequest.put(
    `${UPDATE_SOCIAL_TRADING_PROVIDER_API}/${providerId}`,
    updateSocialTradingProviderDetails
  );
};

const fetchSocialTradingProviderPortfolio = () => {
  return socialTradingRequest.get(
    FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO_API
  );
};

const updateSocialTradingSubscription = (
  updateSocialTradingSubscriptionDetails
) => {
  const { subscriptionId, ...data } =
    updateSocialTradingSubscriptionDetails || {};
  return socialTradingRequest.put(
    `${UPDATE_SOCIAL_TRADING_SUBSCRIPTION_API}/${subscriptionId}`,
    data
  );
};

const fetchSocialTradingSubscriptionDetails = (
  socialTradingSubscriptionParams
) => {
  return socialTradingRequest.get(
    `${FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS_API}/${socialTradingSubscriptionParams.subscriptionId}`
  );
};

const fetchSocialTradingSubscriptionDeals = (
  socialTradingSubscriptionDealsParams
) => {
  const { subscriptionId, ...params } =
    socialTradingSubscriptionDealsParams || {};
  const url = FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS_API.replace(
    SocialTradingSubscriptionIdParamValue,
    subscriptionId
  );
  return socialTradingRequest.get(url, { params });
};

const fetchSocialTradingSubscriptionMetrics = (
  socialTradingSubscriptionMetricsParams
) => {
  const url = FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS_API.replace(
    SocialTradingSubscriptionIdParamValue,
    socialTradingSubscriptionMetricsParams.subscriptionId
  );
  return socialTradingRequest.get(url);
};

const fetchSocialTradingSubscriptionTradingResults = (
  socialTradingSubscriptionTradingResultsParams
) => {
  const { subscriptionId, ...params } =
    socialTradingSubscriptionTradingResultsParams || {};
  const url = FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS_API.replace(
    SocialTradingSubscriptionIdParamValue,
    subscriptionId
  );
  return socialTradingRequest.get(url, { params });
};

const fetchSocialTradingSubscriptionRisk = (
  socialTradingSubscriptionRiskParams
) => {
  const url = FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK_API.replace(
    SocialTradingSubscriptionIdParamValue,
    socialTradingSubscriptionRiskParams.subscriptionId
  );
  return socialTradingRequest.get(url);
};

const updateSocialTradingSubscriptionRisk = (
  updateSocialTradingSubscriptionRiskDetails
) => {
  const { subscriptionId, ...data } =
    updateSocialTradingSubscriptionRiskDetails || {};
  const url = UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK_API.replace(
    SocialTradingSubscriptionIdParamValue,
    subscriptionId
  );
  return socialTradingRequest.put(url, data);
};

const deleteSocialTradingSubscription = (socialTradingSubscriptionDetails) => {
  const { subscriptionId, ...data } = socialTradingSubscriptionDetails || {};
  const url = `${DELETE_SOCIAL_TRADING_SUBSCRIPTION_API}/${subscriptionId}`;
  return socialTradingRequest.delete(url, { data });
};

const fetchSocialTradingFollowerPortfolio = () => {
  return socialTradingRequest.get(
    FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO_API
  );
};

const fetchSocialTradingFollowerPositions = (
  socialTradingFollowerPositionsParams
) => {
  const url = FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS_API.replace(
    SocialTradingSubscriptionIdParamValue,
    socialTradingFollowerPositionsParams.subscriptionId
  );
  return socialTradingRequest.get(url);
};

const fetchSocialTradingOfferDetails = (socialTradingOfferDetailsParams) => {
  const url = FETCH_SOCIAL_TRADING_OFFER_DETAILS_API.replace(
    SocialTradingOfferIdParamValue,
    socialTradingOfferDetailsParams.offerId
  );
  return socialTradingRequest.get(url);
};

const fetchSocialTradingFees = (socialTradingFeesParams) => {
  return socialTradingRequest.post(
    FETCH_SOCIAL_TRADING_FEES_API,
    socialTradingFeesParams
  );
};

const subscribeAggregate = (subscribeAggregateDetails) => {
  return socialTradingRequest.post(
    SUBSCRIBE_AGGREGATE_API,
    subscribeAggregateDetails
  );
};

const submitProviderApplication = (applicationDetails) => {
  return socialTradingRequest.post(
    SUBMIT_PROVIDER_APPLICATION_API,
    applicationDetails
  );
};

const submitProviderAggregate = (providerAggregateDetails) => {
  return socialTradingRequest.post(
    SUBMIT_PROVIDER_AGGREGATE_API,
    providerAggregateDetails
  );
};

const fetchSocialTradingRateProfile = (socialTradingRateProfileParams) => {
  const { profileId } = socialTradingRateProfileParams || {};
  const url = FETCH_SOCIAL_TRADING_RATE_PROFILE_API.replace(
    SocialTradingProfileIdParamValue,
    profileId
  );
  return socialTradingRequest.get(url);
};

const fetchSocialTradingHistoryIndicators = (
  socialTradingHistoryIndicatorsParams
) => {
  const { accountId } = socialTradingHistoryIndicatorsParams || {};
  const url = FETCH_SOCIAL_TRADING_HISTORY_INDICATORS_API.replace(
    SocialTradingAccountIdParamValue,
    accountId
  );
  return socialTradingRequest.get(url);
};

const fetchSocialTradingInstrumentReport = (
  socialTradingInstrumentReportParams
) => {
  const { accountId } = socialTradingInstrumentReportParams || {};
  const url = FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT_API.replace(
    SocialTradingAccountIdParamValue,
    accountId
  );
  return socialTradingRequest.get(url);
};

const fetchSocialTradingTradeReport = (socialTradingTradeReportParams) => {
  const { accountId } = socialTradingTradeReportParams || {};
  const url = FETCH_SOCIAL_TRADING_TRADE_REPORT_API.replace(
    SocialTradingAccountIdParamValue,
    accountId
  );
  return socialTradingRequest.get(url);
};

export const socialTradingService = {
  fetchSocialTradingProviders,
  fetchSocialTradingProviderOffers,
  subscribeToSocialTradingProvider,
  submitSocialTradingProvider,
  submitSocialTradingProviderOffer,
  fetchSocialTradingProvidersConfig,
  fetchSocialTradingProviderPositions,
  fetchSocialTradingProviderDetails,
  fetchSocialTradingHistoryDailyChart,
  fetchSocialTradingProviderMetrics,
  fetchSocialTradingProviderSubscriptions,
  fetchSocialTradingProviderDeals,
  updateSocialTradingProvider,
  fetchSocialTradingProviderPortfolio,
  updateSocialTradingSubscription,
  fetchSocialTradingSubscriptionDetails,
  fetchSocialTradingSubscriptionDeals,
  fetchSocialTradingSubscriptionMetrics,
  fetchSocialTradingSubscriptionTradingResults,
  fetchSocialTradingSubscriptionRisk,
  updateSocialTradingSubscriptionRisk,
  deleteSocialTradingSubscription,
  fetchSocialTradingFollowerPortfolio,
  fetchSocialTradingFollowerPositions,
  fetchSocialTradingOfferDetails,
  fetchSocialTradingFees,
  subscribeAggregate,
  submitProviderApplication,
  submitProviderAggregate,
  fetchSocialTradingRateProfile,
  fetchSocialTradingHistoryIndicators,
  fetchSocialTradingInstrumentReport,
  fetchSocialTradingTradeReport,
};
